import cf from './cf';
import i1zv2_20211024 from './i1zv2_20211024';

export default class i1zv2b extends i1zv2_20211024 {

  constructor(props) { // state の宣言だけでは駄目な模様
    super(props);
//    this.class = this.constructor.name;
//    this.class = 'i1zv1b';
    this.d_viewDefs = {
      name: 'エントリーの確認、キャンセル・新規エントリー',
      class: 'i1zv2b',
    };
    this.state = cf.myRN_crt_stss(
      this.$cd_stss,
      this.$id_stss
    );
//    this.i1zrt11i = 20; // 登録区分
//    this.class = 'i1zv1b'; // 登録区分
  }

}
